module.exports = __webpack_public_path__ + "assets/img/home-service-price-light.3f6f68c2.png";